import { Col, Row } from 'react-bootstrap';
import { FormWithValidation } from 'shared/form';
import { Button } from '@orbita-ui/core';
import { useForm } from 'react-hook-form';
import { useFileDownloader } from 'shared/hooks/useFileDownloader';
import { useCoreService } from 'core/services/useCoreService';
import { useState } from 'react';
import { useNotifications } from 'shared/notifications';

interface MovimientosLiquidadosFormData {
  from: Date | null;
  to: Date | null;
}

const CLEAN_FORM_VALUE: Partial<MovimientosLiquidadosFormData> = {
  from: null,
  to: null,
};

export const MovimientosLiquidadosForm = () => {
  const { downloadFile } = useFileDownloader();
  const coreService = useCoreService();
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification } = useNotifications();

  const methods = useForm<MovimientosLiquidadosFormData>({
    defaultValues: CLEAN_FORM_VALUE,
  });
  const localSubmit = async (formData: MovimientosLiquidadosFormData) => {
    try {
      setIsLoading(true);
      const fileData = await coreService.getReporteMovimientosLiquidados(formData);
      downloadFile(fileData);
    } catch (e) {
      addNotification('Hubo un error al descargar el reporte', 'error');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <FormWithValidation reactFormHookMethods={methods} onSubmit={localSubmit}>
      <Row>
        <Col>
          <FormWithValidation.Datepicker
            label="Desde"
            name="from"
            mode="single"
            fullWidthDialog
          />
        </Col>
        <Col>
          <FormWithValidation.Datepicker
            label="Hasta"
            name="to"
            mode="single"
            fullWidthDialog
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-end" style={{ gap: 8 }}>
        <Button
          type="button"
          variant="outline"
          color="destructive"
          onClick={() => methods.reset(CLEAN_FORM_VALUE)}
        >
          Limpiar
        </Button>
        <Button type="submit" loading={isLoading} disabled={isLoading}>
          Generar Reporte
        </Button>
      </div>
    </FormWithValidation>
  );
};
